import { GraphQLError } from 'graphql';

export function selectErrorMessage(errors: readonly GraphQLError[] | Error): string {
  return errors instanceof Error ? errors.message : errors[0].message;
}

export const EMAIL_VERIFICATION_ERROR = 'Email not verified';
